import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  overflowX: 'hidden',
  width: theme.spacing(64.375),
  margin: 'auto',
  '& .mdr-moreDiscountWrapper': {
    display: 'flex',
    alignItems: 'stretch',
    padding: theme.spacing(1, 1, 1, 0), // paddingRight 1 if dispayed cards are 4, and 4 if displayed cards are 3
    marginTop: theme.spacing(1),
    flexFlow: 'row nowrap',
    transform: 'translateX(0)',
    textAlign: 'center',
    transition: 'transform 300ms cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  '& .mdr-info': {
    position: 'relative',
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexFlow: 'column',
    flex: '1 1 20%',
    flexBasis: '20%',
    maxWidth: '7.5rem',
    minWidth: '20%',
    '&:not(:last-child)::after': {
      content: '""',
      position: 'absolute',
      backgroundColor: theme.palette.grey['100'],
      width: theme.spacing(0.125),
      height: theme.spacing(4.5),
      transform: 'translateY(-50%)',
      top: '50%',
      right: 0,
    },
  },
  '& .mdr-price': {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    color: theme.palette.secondary.dark,
  },
  '& .mdr-smallText': {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: '400',
    lineHeight: theme.spacing(2),
  },
  '& .mdr-grey300': {
    color: theme.palette.grey['300'],
  },
  '& .mdr-per': {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2),
  },
}));
export default StyledBox;
